import { SiteModel } from '@wix/thunderbolt-ssr-api'

export const bodyCachableChecker = ({ model }: SiteModel) => model.ssrModel.togglerCacheResult?.shouldRender ?? false
